import { INDICATOR } from '@voladeum/client';
import { STRATEGY_OPTION } from 'enums';

import { StrategyOption } from './types';

export const indicators_oscillator = [
  INDICATOR.ADX,
  INDICATOR.RSI,
  INDICATOR.STOCHASTIC_RSI,
  INDICATOR.STOCHASTIC,
  INDICATOR.WILLIAMS_R,
  INDICATOR.MFI,
  INDICATOR.ROC,
  INDICATOR.CHAIKIN,
  INDICATOR.VOLUME_ROC,
];

export const indicators_advanced = [
  INDICATOR.MACD,
  INDICATOR.CCI,
  INDICATOR.OBV,
  INDICATOR.ACCUMULATION_DIST,
  INDICATOR.ATR,
  INDICATOR.STANDARD_DEV,
];

export const strategy_option: Record<STRATEGY_OPTION, string> = {
  [STRATEGY_OPTION.ACTIVATE_STRATEGY]: 'Activate Strategy',
  [STRATEGY_OPTION.UPDATE_STRATEGY]: 'Update Strategy',
  [STRATEGY_OPTION.PUBLISH_STRATEGY]: 'Publish Strategy',
  [STRATEGY_OPTION.ARCHIVE_STRATEGY]: 'Archive Strategy',
};

export const strategy_message: Partial<Record<STRATEGY_OPTION, string>> = {
  [STRATEGY_OPTION.ACTIVATE_STRATEGY]: 'Are you sure you want to Activate this Strategy?',
  [STRATEGY_OPTION.ARCHIVE_STRATEGY]: 'Are you sure you want to Archive this Strategy?',
};

export const strategy_options: StrategyOption[] = [
  {
    name: strategy_option[STRATEGY_OPTION.ACTIVATE_STRATEGY],
    message: strategy_message[STRATEGY_OPTION.ACTIVATE_STRATEGY] || '',
    id: STRATEGY_OPTION.ACTIVATE_STRATEGY,
    uuid: STRATEGY_OPTION.ACTIVATE_STRATEGY,
  },
  {
    name: strategy_option[STRATEGY_OPTION.UPDATE_STRATEGY],
    message: strategy_message[STRATEGY_OPTION.UPDATE_STRATEGY] || '',
    id: STRATEGY_OPTION.UPDATE_STRATEGY,
    uuid: STRATEGY_OPTION.UPDATE_STRATEGY,
  },
  {
    name: strategy_option[STRATEGY_OPTION.PUBLISH_STRATEGY],
    message: strategy_message[STRATEGY_OPTION.PUBLISH_STRATEGY] || '',
    id: STRATEGY_OPTION.PUBLISH_STRATEGY,
    uuid: STRATEGY_OPTION.PUBLISH_STRATEGY,
  },
  {
    name: strategy_option[STRATEGY_OPTION.ARCHIVE_STRATEGY],
    message: strategy_message[STRATEGY_OPTION.ARCHIVE_STRATEGY] || '',
    id: STRATEGY_OPTION.ARCHIVE_STRATEGY,
    uuid: STRATEGY_OPTION.ARCHIVE_STRATEGY,
  },
];
